
import axios from "@/shared/scripts/AutoRefreshAxios";
import store from "@/shared/store";
import {
    GenerateContentPayload,
    GenerateContentResponse,
    TranslateGeneratedContentPayload,
    TranslateGeneratedContentResponse,
} from "@/shared/interfaces/optimizedEncoding/GeneratedContent.interface";


export function generateContent(
    payload: GenerateContentPayload
): Promise<GenerateContentResponse> {
    if (!payload.classifiedId) {
        throw new Error("Missing classifiedId for generate-content");
    }

    const baseUrl: string = process.env.VUE_APP_COMPLETION_URL || "";
    const version = "1";
    const endpoint = "completion";
    const urlend = "generate-content";

    return axios
        .post<GenerateContentResponse>(
            `${baseUrl}${endpoint}/${version}/${urlend}`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": process.env.VUE_APP_COMPLETION_API_KEY,
                    Authorization: "Bearer " + store.getters["UserModule/getUser"].jwtToken,
                },
            }
        )
        .then((res) => res.data)
        .catch((error) => {
            console.error("Got error while generating AI content", error);
            throw error;
        });
}

export function translateGeneratedContent(
    payload: TranslateGeneratedContentPayload
): Promise<TranslateGeneratedContentResponse> {
    const baseUrl: string = process.env.VUE_APP_COMPLETION_URL || "";
    const version = "1";
    const endpoint = "completion";
    const urlend = "translate";

    return axios
        .post<TranslateGeneratedContentResponse>(
            `${baseUrl}${endpoint}/${version}/${urlend}`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": process.env.VUE_APP_COMPLETION_API_KEY,
                    Authorization: "Bearer " + store.getters["UserModule/getUser"].jwtToken,
                },
            }
        )
        .then((res) => res.data)
        .catch((error) => {
            console.error("Got error while translating AI content", error);
            throw error;
        });
}
